import { normalizeFlag } from '@/utils/flags'

export const toDisplayCondition = (value: unknown): string[] =>
  Array.isArray(value)
    ? value
      .filter((condition): condition is string => typeof condition === 'string')
      .map(normalizeFlag)
      .filter(Boolean)
    : []

export const meetsDisplayCondition = (displayCondition: string[], flags: string[]): boolean => {
  if (!displayCondition.length) {
    return true
  }

  const normalizedFlags = flags.map(normalizeFlag)
  return displayCondition.some(condition => normalizedFlags.includes(condition))
}
